module.exports = __webpack_public_path__ + "img/phone-mb.97d561df.png";